import { useCallback, useState } from 'react'
import { m, LazyMotion, domAnimation, useAnimation } from 'framer-motion'

import {
  TalentSpeechBubbleLeft,
  TalentSpeechBubbleRight,
  TalentPortal,
  TalentInteractionLeft,
  TalentInteractionRight,
} from '../../../../assets/icons'

import styles from './index.module.scss'

const LEFT_BUBBLE = {
  start: { opacity: 0.01, y: '100%', x: '-20%' },
  end: {
    opacity: 1,
    y: '0%',
    x: '0%',
    transition: { type: 'spring', bounce: 0, duration: 1.5 },
  },
}

const PORTAL = {
  start: { opacity: 0.01, y: '10%' },
  end: {
    opacity: 1,
    y: '0%',
    transition: { type: 'spring', bounce: 0, duration: 1.5 },
  },
}

const LEFT_INTERACTION = {
  start: { opacity: 0.01, y: '100%', x: '-5%' },
  end: {
    opacity: 1,
    y: '0%',
    x: '0%',
    transition: { type: 'spring', bounce: 0, duration: 1.5 },
  },
}

const RIGHT_INTERACTION = {
  start: { opacity: 0.01, y: '100%', x: '20%' },
  end: {
    opacity: 1,
    y: '0%',
    x: '0%',
    transition: { type: 'spring', bounce: 0, duration: 1.5 },
  },
}

const RIGHT_BUBBLE = {
  start: { opacity: 0.01, y: '100%', x: '20%' },
  end: {
    opacity: 1,
    y: '0%',
    x: '0%',
    transition: { type: 'spring', bounce: 0, duration: 1.5 },
  },
}

const SCROLL_INTO_VIEW = {
  start: { y: '50%', opacity: 0 },
  end: {
    y: '0%',
    opacity: 1,
    transition: { type: 'spring', bounce: 0 },
  },
}

const OlbySpaceGraphics = () => {
  const leftBubbleControl = useAnimation()
  const portalControl = useAnimation()
  const leftInteractionControl = useAnimation()
  const rightBubbleControl = useAnimation()
  const rightInteractionControl = useAnimation()
  const [wasGraphicsAnimationTriggered, setWasGraphicsAnimationTriggered] = useState(false)

  const onGraphicsEnter = useCallback(() => {
    if (wasGraphicsAnimationTriggered) {
      return
    }
    setWasGraphicsAnimationTriggered(true)

    leftBubbleControl.start('end')
    portalControl.start('end')
    leftInteractionControl.start('end')
    rightInteractionControl.start('end')
    rightBubbleControl.start('end')
  }, [
    leftBubbleControl,
    leftInteractionControl,
    portalControl,
    rightBubbleControl,
    rightInteractionControl,
    wasGraphicsAnimationTriggered,
  ])

  return (
    <LazyMotion features={domAnimation} strict>
      <m.div
        className={styles['graphics']}
        onViewportEnter={onGraphicsEnter}
        initial="start"
        viewport={{ once: true, amount: 0.7 }}
      >
        <m.div
          className={styles['left-bubble']}
          animate={leftBubbleControl}
          variants={LEFT_BUBBLE}
          initial="start"
        >
          <TalentSpeechBubbleLeft className={styles['icon']} />
        </m.div>
        <m.div
          className={styles['portal']}
          animate={portalControl}
          variants={PORTAL}
          initial="start"
        >
          <TalentPortal className={styles['icon']} />
        </m.div>
        <m.div
          className={styles['right-interaction']}
          animate={rightInteractionControl}
          variants={RIGHT_INTERACTION}
          initial="start"
        >
          <TalentInteractionRight className={styles['icon']} />
        </m.div>
        <m.div
          className={styles['left-interaction']}
          animate={leftInteractionControl}
          variants={LEFT_INTERACTION}
          initial="start"
        >
          <TalentInteractionLeft className={styles['icon']} />
        </m.div>
        <m.div
          className={styles['right-bubble']}
          animate={rightBubbleControl}
          initial="start"
          variants={RIGHT_BUBBLE}
        >
          <TalentSpeechBubbleRight className={styles['icon']} />
        </m.div>
      </m.div>
      <m.div
        className={styles['graphics-mobile']}
        initial="start"
        viewport={{ once: true, amount: 0.3 }}
        variants={SCROLL_INTO_VIEW}
        whileInView="end"
      >
        <div className={styles['left-bubble']}>
          <TalentSpeechBubbleLeft className={styles['icon']} />
        </div>
        <div className={styles['portal']}>
          <TalentPortal className={styles['icon']} />
        </div>
        <div className={styles['right-interaction']}>
          <TalentInteractionRight className={styles['icon']} />
        </div>
        <div className={styles['left-interaction']}>
          <TalentInteractionLeft className={styles['icon']} />
        </div>
        <div className={styles['right-bubble']}>
          <TalentSpeechBubbleRight className={styles['icon']} />
        </div>
      </m.div>
    </LazyMotion>
  )
}

export default OlbySpaceGraphics
